import { Outlet } from 'react-router-dom'

import { Hug, maxWidths } from '@cash-design-system/react'

export const JourneyLayoutMaxWidth = () => {
  return (
    <Hug maxWidth={maxWidths.content} fullWidth={true}>
      <Outlet />
    </Hug>
  )
}
